module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-3eb16256637f6537b9ff1e35728270ce.ttf";